import { render, staticRenderFns } from "./gtr-badge-preview.vue?vue&type=template&id=b0438d92"
import script from "./gtr-badge-preview.vue?vue&type=script&lang=ts"
export * from "./gtr-badge-preview.vue?vue&type=script&lang=ts"
import style0 from "./gtr-badge-preview.vue?vue&type=style&index=0&id=b0438d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports